export default "__VITE_ASSET__4xWTPhNO__"